import io from 'socket.io-client';
// do przewidzenia
// 1. rozlaczenie z websocketem - zablogowanie zakladki chat
// 2. po ponownym polaczeniu pobierz aktualne rozmowy
// 3.


export default {
  socket: null,
  connect() {
    this.socket = io(process.env.VUE_APP_SOCKET_URL);
  },
  handleSocketDisconnect(callback) {
    if (!this.socket) {
      return false;
    }
    this.socket.on('disconnect', callback);
    return true;
  },
  disconnect() {
    if (!this.socket) {
      return false;
    }
    this.socket.disconnect();
    return true;
  },
  isSocketConnected() {
    return !this.socket ? false : this.socket.connected;
  },
  handleSetSessionConnection(userUuid, callback) {
    if (!this.socket) {
      return false;
    }
    this.socket.on('connect', () => {
      this.socket.emit('handleSetSessionConnection', {
        data: {
          userUuid,
        },
      });
      callback();
    });
    return true;
  },
  $emit(event, payload) {
    this.socket.emit(event, payload);
  },
  $on(event, callback) {
    this.socket.on(event, payload => callback(payload));
  },
  $offAll(events) {
    events.forEach((event) => {
      this.socket.off(event);
    });
  },
};
